import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "@environments/environment";

@Injectable({
  providedIn: "root",
})
export class AskGenAiService {
  constructor(private http: HttpClient) {}

  private genAIiUrl =
    environment.chatBackendBaseURL + "/conversation/ask_genai";
  public response: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);

  askGenAi(
    subscription_id: string,
    query: string,
    context: string = "You are a helpful assistant",
    model: string = "text-bison",
    model_params: any
  ): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        "subscription-id": subscription_id,
        "Content-Type": "application/json",
      }),
    };
    var message = {
      message: query,
      palm_params: {
        model: model,
        context: context,
        parameters: model_params || {
          max_output_tokens: 1024,
          temperature: 0.2,
          top_p: 0.95,
          top_k: 40,
        },
        history: [],
      },
    };
    return this.http.post<any>(`${this.genAIiUrl}`, message, httpOptions);
  }
}
